import { createStyleSheet } from 'Components/foundation/stylesheets';
import COLORS from 'Components/foundation/colors';
import TYPOGRAPHY from 'Components/foundation/typography';

const DEFAULT_MARGIN = '8px';
const DEFAULT_PADDING = '8px';

const styleSheet = createStyleSheet({
  wrapper: {
    height: 'auto',
    width: '100%',
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: DEFAULT_MARGIN,
  },
  title: {
    ...TYPOGRAPHY.HERO_S_SEMIBOLD,
  },
  middleContainer: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${COLORS.GREY_DARK.DEFAULT}`,
    borderRadius: '8px',
    padding: DEFAULT_PADDING,
    marginTop: DEFAULT_MARGIN,
    marginBottom: DEFAULT_MARGIN,
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  middleContainer_hover: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${COLORS.GREY_DARKER.HOVER}`,
    borderRadius: '8px',
    padding: DEFAULT_PADDING,
    marginTop: DEFAULT_MARGIN,
    marginBottom: DEFAULT_MARGIN,
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  textArea: {
    ...TYPOGRAPHY.BODY2,
    height: 'fit-content',
    width: '100%',
    padding: DEFAULT_PADDING,
    color: COLORS.TEXT.DEFAULT,
    resize: 'none',
  },
  bottomContainer: {
    display: 'flex',
  },
});

export default styleSheet;
